export const storiesCategory = 'Mapping Components/';
